<script>
  import { onMount } from "svelte";
  import { auth, onAuthChange } from "../../auth";
  import { onNavigate, getCurrentPath } from "../../router";

  let user = $state(auth.getLoggedUser());
  let currentPath = $state(getCurrentPath());

  onMount(() => {
    const unsubAuth = onAuthChange(() => {
      user = auth.getLoggedUser();
    });
    const unsubNav = onNavigate((path) => {
      currentPath = path;
    });
    return () => {
      unsubAuth();
      unsubNav();
    };
  });

  let loggedIn = $derived(user !== null && user !== undefined);

  function hasRole(...roles) {
    return loggedIn && roles.includes(user.rola);
  }

  function isActive(path) {
    return currentPath === path;
  }

  function logout() {
    auth.logout();
  }
</script>

<!-- navbar -->
<nav class="navbar navbar-fixed-top" id="navbar" role="navigation">
    <div class="container">
        <div class="navbar-header">
            <a class="navbar-brand">
            <img src="mjn-2025.png" width="90" height="16" class="d-inline-block align-top" alt="MJN">
            </a>
            <p class="navbar-text hidden-xs">Centrum Sterowania
            </p>
            {#if loggedIn}<button class="btn btn-sm btn-default navbar-btn visible-xs" onclick={logout}>Wyloguj</button>{/if}
        </div>
        {#if loggedIn}
        <div class="navbar-right hidden-xs">
            <p class="navbar-text">
            Użytkownik: {user.nazwa} ({user.rola})
            </p>
            <button class="btn btn-sm btn-default navbar-btn" onclick={logout}>Wyloguj</button>
        </div>
        {/if}
    </div>
    {#if loggedIn}
    <div class="hidden-xs nav navbar-nav side-nav">
		<ul class="nav nav-pills nav-stacked">
            <p class="side-nav-header">Ludzie</p>
			<li class:active={isActive("/")}><a href="/"><i class="fas fa-user-friends fa-lg fa-fw"></i>&nbsp;&nbsp;Ludzie</a></li>
			{#if hasRole("admin", "user")}<li class:active={isActive("/transfers")}><a href="/transfers"><i class="fas fa-credit-card fa-lg fa-fw"></i>&nbsp;&nbsp;Przelewy</a></li>{/if}
			{#if hasRole("admin", "user")}<li class:active={isActive("/actions")}><a href="/actions"><i class="fas fa-briefcase-medical fa-lg fa-fw"></i>&nbsp;&nbsp;Umorzenia, zawieszenia</a></li>{/if}
			{#if hasRole("admin", "user")}<li class:active={isActive("/contributions")}><a href="/contributions"><i class="fas fa-piggy-bank fa-lg fa-fw"></i>&nbsp;&nbsp;Składki</a></li>{/if}
            {#if hasRole("admin", "user")}<li class:active={isActive("/slack")}><a href="/slack"><i class="fab fa-slack fa-lg fa-fw"></i>&nbsp;&nbsp;Slack</a></li>{/if}
            {#if hasRole("admin", "user")}<li class:active={isActive("/issues")}><a href="/issues"><i class="fas fa-exclamation-circle fa-lg fa-fw"></i>&nbsp;&nbsp;Problemy</a></li>{/if}
            {#if hasRole("admin", "user")}<p class="side-nav-header">Ewidencje</p>{/if}
            {#if hasRole("admin", "user")}<li class:active={isActive("/projects")}><a href="/projects"><i class="fas fa-funnel-dollar fa-lg fa-fw"></i>&nbsp;&nbsp;Projekty</a></li>{/if}
            {#if hasRole("admin")}<p class="side-nav-header">Administracja</p>{/if}
            {#if hasRole("admin")}<li class:active={isActive("/users")}><a href="/users"><i class="fas fa-user-circle fa-lg fa-fw fa-fw"></i>&nbsp;&nbsp;Użytkownicy</a></li>{/if}
            {#if hasRole("admin")}<li class:active={isActive("/logs")}><a href="/logs"><i class="fas fa-book fa-lg fa-fw"></i>&nbsp;&nbsp;Dziennik zdarzeń</a></li>{/if}
            <p class="side-nav-header">Pomoc</p>
            <li class:active={isActive("/info")}><a href="/info"><i class="fas fa-info-circle fa-lg fa-fw"></i>&nbsp;&nbsp;Pomoc</a></li>
		</ul>
    </div>
    {/if}
</nav>

<!-- bottom toolbar shown on small devices -->
{#if loggedIn}
<nav class="navbar navbar-inverse navbar-fixed-bottom visible-xs">
 <div class="container-fluid">
   <ul class="nav navbar-nav">
       <li class:active={isActive("/")}><a href="/"><i class="fas fa-user-friends"></i></a></li>
       <li class:active={isActive("/transfers")}><a href="/transfers"><i class="fas fa-credit-card"></i></a></li>
       <li class:active={isActive("/actions")}><a href="/actions"><i class="fas fa-briefcase-medical"></i></a></li>
       <li class:active={isActive("/contributions")}><a href="/contributions"><i class="fas fa-piggy-bank"></i></a></li>
       <li class:active={isActive("/projects")}><a href="/projects"><i class="fas fa-funnel-dollar"></i></a></li>
       {#if hasRole("admin")}<li class:active={isActive("/users")}><a href="/users"><i class="fas fa-user-circle"></i></a></li>{/if}
       {#if hasRole("admin")}<li class:active={isActive("/logs")}><a href="/logs"><i class="fas fa-book"></i></a></li>{/if}
       <li class:active={isActive("/info")}><a href="/info"><i class="fas fa-info-circle"></i></a></li>
   </ul>
 </div>
</nav>
{/if}
